/**
 * Сортировка строк по колонке: `null`/`undefined`/NaN — всегда в конце
 * (в обе стороны), строки — по-русски, равные — в исходном порядке.
 */
export function sortBy(rows, sort, valueOf) {
    const sign = sort.dir === 'asc' ? 1 : -1;
    const empty = (v) => v === null || v === undefined || (typeof v === 'number' && Number.isNaN(v));
    return rows
        .map((row, i) => ({ row, i, v: valueOf(row, sort.key) }))
        .sort((a, b) => {
        const ea = empty(a.v);
        const eb = empty(b.v);
        if (ea || eb)
            return ea === eb ? a.i - b.i : ea ? 1 : -1;
        const c = typeof a.v === 'number' && typeof b.v === 'number'
            ? a.v - b.v
            : String(a.v).localeCompare(String(b.v), 'ru');
        return c !== 0 ? sign * c : a.i - b.i;
    })
        .map((x) => x.row);
}
/** Порядок вывода для сортировки: да > неясно > нет; «мало покупок» — нет значения. */
export function verdictRank(v) {
    return v === 'yes' ? 3 : v === 'unclear' ? 2 : v === 'no' ? 1 : null;
}
/** Страница строк (1-based). */
export function pageOf(rows, page, size) {
    const pages = Math.max(1, Math.ceil(rows.length / size));
    const p = Math.min(Math.max(1, page), pages);
    return rows.slice((p - 1) * size, p * size);
}
//# sourceMappingURL=table-sort.js.map